module.exports = __webpack_public_path__ + "img/051-A.236a40cd.png";